import { Button, Card, CardContent, Chip, GridLegacy as Grid, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, useMediaQuery } from '@mui/material';
import dayjs from '../../../utils/dayjs-setup';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, DatePickerInputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance,  DateFormatString, DialogType, EstadosPedido, FormActions, FormatPrice, TiposPedidos, } from "../../../utils/constants";
import * as yup from "yup";
import { FilterForm } from "../../../components/form/filter-form";
import { ModalVerPedidos } from "../../../components/modals/modal-ver-pedidos";
import { ModalLanzarNecesidad } from "../../../components/modals/modal-lanzar-necesidad";
import { ModalFormGenerador, ModalFormMultiple } from "../../../components/form/ModalForm";
import { CustomDialog as YesNotDialog } from "../../../components/modals/custom-dialog";
import CustomContextMenu from "../../../components/context-menu";
import { useClientCreationPedido } from "../../../hooks/useClientCreationPedido";
import { useCreationPedido } from "../../../hooks/useCreationPedido";
import { useClientActivacion } from "../../../hooks/useClientActivacion";






const schemaFilter = yup.object({
  

}).required();



const schemaDescargarPedidos = yup.object({
  centro_operacion: yup.object().required(),
  fecha_entrega:yup.string().required()
 
}).required();


const schemaPedidos = yup.object({
  tipo_pedido:yup.string().required(),
  cliente: yup.object().required(),
  sucursal_proveedor: yup.string().required(),
  tipo_entrega: yup.string().required(),
  medio_pago: yup.string().required(),
  tipo_credito:yup.string().notRequired().nullable(),
  fecha_entrega: yup.string().required(),
  productos_list:yup.array().min(1).required(),
  persona_contacto:yup.string().required(),
}).required();


const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};


const defaultEntity = {
  tipo_entrega:"ED",
  fecha_entrega:null,
  tipo_pedido:"PEDIDO",
  medio_pago:null,
  fecha_entrega:null,
  persona_contacto:null,
  sucursal_proveedor:null,
  centro_operacion:null,
  productos_list:[]

};


export const MaestrosPedidos = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const configuracionApp = profile.configuracion_comp? JSON.parse(profile.configuracion_comp):{};
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [isVisibleModalLanzar,setIsVisibleModalLanzar] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...defaultEntity});
  const [estadosOptions,setEstadosOptions] = useState([]);
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [clientes,setClientes] = useState([]);
  const [dialogYesConfig,setDialogYesConfig] = useState({});
  const [dialogExportConfig,setDialogExportConfig] = useState({});
  const [centrosOperacion,setCentrosOperacion] = useState([]);
  const [is_visible_modal_multiple,set_is_visible_modal_multiple] = useState(false);
  const [maestrosCompartidos,setMaestrosCompartidos] = useState({
    tipos_identificacion:[],
    tipos_clientes:[],
    tipo_persona:[],
    sucursales_activas:[],
    medios_pagos:[],
    estados_pedidos:[],
    condiciones_entrega:[],
  });
  const is_mobile = useMediaQuery('(max-width:600px)');

    

  useEffect(()=>{
    loadInitData();
  },[]);
     useEffect(()=>{
  
      setTimeout(() => {
         loadItems(true);
      }, 500);
    
    },[filterSearchPagination]); 


    const loadInitData = async()=>{
     
      await loadMaestrosPedidos();

   
    }
    
    const loadMaestrosPedidos = async()=>{
      const  {data:{value}} = await AxiosInstance.get("maestros-marketplace/get-maestros-pedidos");
      setMaestrosCompartidos(value);
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      console.log("load");
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: true
      });
      if (loading){
       
      }

     let {data:{value}} = await AxiosInstance.post(`maestros-marketplace/get-pedidos-list/${profile.cod_cia || ''}`,{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const  setFilterAply = (filtros)=>{
      console.log({filtros});
      
      setFilterSearchPagination({
        ...InitialFilterSearch,
        cliente:filtros.client_select?.value,
        //producto:filtros.product_select?.value,
        estado_pedido:filtros.estado_pedido,
        fecha:dayjs(filtros.fecha_entrega).isValid()? dayjs(filtros.fecha_entrega).format(DateFormatString):null
      });
  
      loadItems(true,{
        ...InitialFilterSearch,
        cliente:filtros.client_select?.value,
        //producto:filtros.product_select?.value,
        estado_pedido:filtros.estado_pedido,
        fecha:dayjs(filtros.fecha_entrega).isValid()? dayjs(filtros.fecha_entrega).format(DateFormatString):null
      });
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

    const onShowDetailProduct = (cod_prod)=>{
     
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: true
      });

     AxiosInstance.get(`maestros-marketplace/get-detalle-pedido/${product.cod}/${product.cliente_cod}`)
     .then(({data:{value}})=>{

      product.detalle_pedido = value;
      setProductoSeleccionado(product);
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);

     }).catch(error=>{
      dispatch({
        type:ActionTypes.setModalInfo,
        data:{
            title:"Error",
            message:"Error de comunicacion verifique su conexion a internet",
            type:DialogType.peligro,
            isVisible:true
        }
    });
     }).finally(()=>{
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: false
      });
     });

    }

    const getPedidoForEdition = (pedido_id)=>{
      return  AxiosInstance.get("maestros/get-pedido-for-edit/"+pedido_id);
    }


    const onOpenModalItem = (edit=false)=>{
 
      if (!edit){
        setProductoSeleccionado({});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
    const urlService = typeAction === FormActions.AGREGAR?'maestros-marketplace/add-clasificacion-clientes':'maestros-marketplace/edit-clasificacion-clientes/'+dataForm.cod;
 
        let payload =  {...dataForm  };
      

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }



    const onCreateNecesidades = async(dataForm)=>{
    
   
  
      const urlService = 'maestros-marketplace/lanzar-necesidad-pedido';
 
        let payload =  {...dataForm  };
      

        setIsVisibleModalLanzar(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
      
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }




    const getNecesidadesLanzadas = (entity)=>{

      return entity.detalle_pedido.filter((item)=>{
        return item.necesidad_count >0?true:false;
 });
    }
    const HasAllNecesidadesLaunch = (entity)=>{
   
       return getNecesidadesLanzadas(entity).length === entity.detalle_pedido.length;
    }

    const LanzarNecesidad = (entity)=>{

      if( HasAllNecesidadesLaunch(entity) ){
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Advertencia",
              message:"Las necesidades ya han sido lanzadas",
              type:DialogType.peligro,
              isVisible:true
          }
      });
      return;
      }
      setIsVisibleModalLanzar(true);
      setProductoSeleccionado(entity);
      console.log("Can Launch");
    }

    const ConvertirCotizacionToPedido = (cod_cotizacion)=>{

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      AxiosInstance.post("maestros-marketplace/convertir-cotizacion-pedido",{cod_cotizacion})
      .then(async res=>{
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Pedido realizado exitosamente",
              message:"El pedido ha sido realizado de forma exitosa recuerde que debe gestionarlo",
              type:DialogType.exitoso,
              isVisible:true
          }
      });
       await loadItems(true);
      })
      .catch(err=>{
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Error",
              message:"Error de comunicacion verifique su conexion a internet",
              type:DialogType.peligro,
              isVisible:true
          }
      });
      }).finally(()=>{
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      });

    }

    const onEditPedido = async(cod_pedido)=>{
 
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      const  {data:{value}}  =   await getPedidoForEdition(cod_pedido);
      const prodList = value.productos_list.map( item=>(
        {
            key:item.oferta.cod_oferta,
            producto:{
              ...item.oferta,
              cod_detalle_pedido:item.cod_detalle_pedido,
              total_disponible_inv:item.total_disponible_inv
            },
            cod_detalle_pedido:item.cod_detalle_pedido,
            observaciones:item.observacion,
            cantidad:item.cantidad}
      ));
      setProductoSeleccionado({
        ...value,
        productos_list:prodList
      });
      setTipoAction(FormActions.MODIFICAR);
      set_is_visible_modal_multiple( true);

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }

  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
      {
      
        key:"nombre_cliente",
        keyValue:"nombre_cliente",
        label:"Cliente",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"centro_operacion",
        keyValue:"centro_operacion",
        label:"Centro de operacion",
        headerRender:(props)=>props.label,
        bodyRender:({value,otherProps})=>`${value} - ${otherProps.municipio_descripcion}`,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },

       {
      
        key:"fecha_entrega",
        keyValue:"fecha_entrega",
        label:"Fecha de entrega",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>dayjs(props.value).format(DateFormatString),
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"total_valor_pedido",
        keyValue:"total_valor_pedido",
        label:"Valor total pedido",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value?FormatPrice(props.value): 0,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      
       {
      
        key:"tipo_pedido",
        keyValue:"tipo_pedido",
        label:"Tipo de pedido",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Chip color={props.value == 'PEDIDO'?'primary':'secondary'}  label={TiposPedidos[props.value]} />,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"estado_nombre",
        keyValue:"estado_nombre",
        label:"Estado del pedido",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Chip color={EstadosPedido[props.value]?.color} label={EstadosPedido[props.value]?.label} />,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  {
      
        key:"acciones",
        keyValue:"cod",
        label:"Acciones",
        headerRender:(props)=>props.label,
        bodyRender:({value,prod_index,info,otherProps})=><>
          <CustomContextMenu
         title_basic="Acciones"
         menuItems={[
          {
                    label: otherProps.tipo_pedido !== 'PEDIDO'?'Descargar cotización':"Descargar pedido",
                    onClick:()=>DownloadDocumento(value,otherProps.tipo_pedido === 'PEDIDO'?'PV':'CT'),
                    disabled:!["PEDIDO","COTIZACION"].includes(otherProps.tipo_pedido)
          },
          {
            label: "Matriz de alistamiento",
            onClick:()=>DownloadDocumento(value,"MA"),
            disabled:!["PEDIDO","COTIZACION"].includes(otherProps.tipo_pedido)
          },
          {
            label:"Editar pedido",
            onClick:()=>onEditPedido(value),
            disabled:!['RECIBIDO','CREADO','EN-ALISTAMIENTO','ALISTADO',"PROCESADO-CON-ERROR"].includes(otherProps.estado_nombre)
          },
          {
            label:"Ver detalle",
            onClick:e=>onShowDetailProduct(value),
            disabled:false
          },
          {
            label:"Ver errores",
            onClick:e=>ShowLogErrores(otherProps.log_errores),
            disabled:otherProps.log_errores?false:true

          },
          {
            label:"Lanzar necesidad",
            onClick:e=>LanzarNecesidad(otherProps),
            disabled:otherProps.tipo_pedido === 'PEDIDO' || otherProps.tipo_pedido === 'COTIZACION'
          },
          {
            label:"Convertir a pedido",
            onClick:e=>ConvertirCotizacionToPedido(value),
            disabled:otherProps.tipo_pedido === 'PEDIDO'  || otherProps.estado_nombre !== 'EN-ESPERA' || dayjs().isAfter(otherProps.vigencia) 
          },
          
         ]}
          />
        </>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },

 
    ];
   



    const onSearchClient = async (value_search) => {

      if (value_search) {
         try{
  
          const { data: { value } } = await AxiosInstance.post("maestros-marketplace/get-clientes-filtro", {
            text_search: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }
  
    const searcClient = async (event, newInputValue) => {
      try {
        let res = await onSearchClient(newInputValue);
        setClientes(res);
      } catch (e) {
  
      }
    }

    const InputFilters = [
      {
        grid:{
          xs:12,
          md:2,
          sm:12
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"client_select",
        InputComponentProps:{
          label:"Cliente",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
      /*     PopperComponent:(props)=><div hidden={!props.open} >
           
             {props.children}
          </div>, */
          onInputChange: searcClient,
          options: clientes || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },{
      grid:{
        xs:6,
        md:2,
        sm:6
      },
      InputComponent:DatePickerInputWithLabel,
      keyValue:"fecha_entrega",
      inputProps:{
        size:'small',
      },
      InputComponentProps:{
        label:"Fecha de entrega",
        fullWidth:true,
        isLoading:false,
        inputFormat:"DD-MM-YYYY",
        value:null,
        size:'small',
        //onInputChange:searchMunicipiosOrigen,
       
      }
    },
    {
      grid:{
        xs:6,
        md:2,
        sm:6
      },
    
      InputComponent:SelectInputWithLabel,
      keyValue:"estado_pedido",
      items: [
        {label:"Todos",value:null}
      ].concat(estadosOptions),
      InputComponentProps:{
        label:"Estado",
        fullWidth:true,
        isLoading:false,
        size:'small',
        value:true
        //onInputChange:searchMunicipiosOrigen,
       
      }
    }
    ];

    
    const onSendChangeEstatusPedid = (payload)=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
       AxiosInstance.post("maestros-marketplace/update-status-pedido",payload).then(({data})=>{
        loadItems();
        if ( !data.status ){
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Proceso no completado",
                message:data.msg,
                type:DialogType.informativo,
                isVisible:true
            }
        });
          return ;
        }
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Accion realizada con exito",
              message:"",
              type:DialogType.exitoso,
              isVisible:true
          }
      });
    

      

      }).catch(error=>{
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Error",
              message:"Error de comunicacion verifique su conexion a internet",
              type:DialogType.peligro,
              isVisible:true
          }
      });

      }).finally(()=>{
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      });
     
      
     
    }

    const onUpdateStatusRequest = async(payload)=>{



      if ( payload.action === 'CANCELADO' ){
        setDialogYesConfig({
          isOpened:true,
          type:DialogType.informativo,
          title:"Confirmar Accion",
          content:"¿Esta seguro que desea cancelar el pedido?",
          actions:[
            {
              title:"NO, No lo estoy",
              buttomProps:{
                variant:"contained",
                size:"small",
                color:"secondary",
                onClick:()=>{
                  setDialogYesConfig({});
                }
              }
            },
            {
              title:"SI, Confirmar",
              buttomProps:{
              
                variant:"contained",
                size:"small",
                color:"primary",
                onClick:()=>{
                  setDialogYesConfig({});
                  onSendChangeEstatusPedid(payload);
                }
              }
            },
            
          ]
        });

      }else if ( payload.action === 'ALISTADO' ){
        console.log(payload.productInfo.cod_usuario_alistamiento !== profile.cod && (payload.productInfo.cod_usuario_alistamiento != null));
        if ( payload.productInfo.cod_usuario_alistamiento !== profile.cod && (payload.productInfo.cod_usuario_alistamiento != null)  ){
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"El proceso no se puede llevar a cabo por que otro usuario tiene abierto el proceso",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        return;
        }

         
          const countNews = payload.productInfo.detalle_pedido.reduce( (counter,item)=>{
               if ( ( [null,''].includes(item.cantidad_inv) || Number( item.cantidad_inv ) < item.cantidad  ) && item.cod_erp_producto != configuracionApp.CREACION_PEDIDOS.item_domicilio   ){
                 return counter+1;
               }
               return counter;
          },0 );
         
          if ( countNews > 0 ){

            setDialogYesConfig({
              isOpened:true,
              type:DialogType.informativo,
              title:"Confirmar Accion",
              content:"Su alistamiento presenta novedades </br></br> ¿Desea dar por finalizado el alistamiento?",
              actions:[
                {
                  title:"NO",
                  buttomProps:{
                    variant:"contained",
                    size:"small",
                    color:"secondary",
                    onClick:()=>{
                      setDialogYesConfig({});
                    }
                  }
                },
                {
                  title:"SI, Confirmar",
                  buttomProps:{
                  
                    variant:"contained",
                    size:"small",
                    color:"primary",
                    onClick:()=>{
                      setDialogYesConfig({});
                      
                      payload.productInfo.detalle_pedido = payload.productInfo.detalle_pedido.map( detalle_item=>{
                        return {
                          ...detalle_item,
                          cantidad_inv:detalle_item.cantidad
                        }
                      } );
                      
                      onSendChangeEstatusPedid(payload);
                    }
                  }
                },
                
              ]
            });
            
          }else{
            payload.productInfo.detalle_pedido = payload.productInfo.detalle_pedido.map( detalle_item=>{
              return {
                ...detalle_item,
                cantidad_inv:detalle_item.cantidad
              }
            } );
            
            onSendChangeEstatusPedid(payload);
          }
          
        
      }else{
        onSendChangeEstatusPedid(payload);
      }
   


    

    }




    const DownloadDocumento = (cod,tipo)=>{

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      AxiosInstance.get(`maestros/descargar-documento-by-oc/${cod}/${tipo}`)
      .then(({data})=>{
        let element = document.createElement("a");
        element.style.display = 'none';
        element.href = `data:application/pdf;base64,${data.base_64}`;
        element.download =  data.name_pdf;
       // document.body.appendChild(element);
        element.click();
       // document.body.removeChild(element); 
      }).catch(err=>{
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Error de consulta documento",
            message: "Se ha presentado un error consultando el documento",
            type: DialogType.informativo,
            isVisible: true
          }
        });
      }).finally(()=>{
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      });

    }



    const onSearchCentroOpModal = async (value_search, type_enter) => {
      console.log({value_search});
      if (value_search.target.value && value_search.target.value.length > 2 && value_search.target.value.length % 2 === 0) {
          try {
    
              const { data: { value } } = await AxiosInstance.post("maestros-marketplace/get-centros-operacion-filtros", {
                  search_query: value_search.target.value
              });
              setCentrosOperacion(value)
            
              return value;
          } catch (e) {
            console.error(e.message);
              return [];
          }
    
      }
    
    }

    const ShowLogErrores = (ErrorLogs)=>{
      dispatch({
        type:ActionTypes.setModalInfo,
        data:{
            title:"Log de errores",
            message:ErrorLogs,
            type:DialogType.peligro,
            isVisible:true
        }
    });
    }

    const onDownloadFile = (typeAction,payload)=>{
      console.log({typeAction,payload});

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
            AxiosInstance.post("maestros/descargar-pedidos",{
              centro_operacion:payload.centro_operacion.value,
              fecha_entrega:dayjs(payload.fecha_entrega).format(DateFormatString)
            }).then( ({data})=>{
                
            } ).catch(err=>{

              dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Error",
                    message:"Error de comunicacion verifique su conexion a internet",
                    type:DialogType.peligro,
                    isVisible:true
                }
            });

            }).finally(()=>{
              dispatch({
                type:ActionTypes.setLoadingPage,
                data:false
              });
            });

    }

  const configDescargaPedido =  {
      entityValues:{centro_operacion:null,fecha_entrega:dayjs()},
      titleModal: "Descargar pedidos",
      buttomsAction:[
          {
            title:"Cancelar",
            buttomProps:{
              type:"button",
              onClick:()=>{
                setDialogExportConfig({isVisible:false});
               
              },
              color:"secondary"
          }
          },
          {
            title:"Descargar listado",
            buttomProps:{
              type:"submit",
            //  onClick:onSaveModData
            }
          }
      ],
      imputs:[
     
        {
          key:"centro_operacion",
          keyValue:"centro_operacion",
          label:"Centro de operacion",
          responsiveSize:12,
          component: AutoCompleteInputWithLabel,
              inputProps: {
                size:"small",
                typeInput:"autoComplete",
               name:'cliente',
                fullWidth: true,
                isLoading: false,
                //callFuncionOnChange:onSearchSucursalesClientes,
                onInputChange: onSearchCentroOpModal,
                options: centrosOperacion || [],
                noOptionsText: "Lista vacia",
                getOptionLabel: (option) => option.label,
                isOptionEqualToValue: (option, value) => option.value === value.value,
                filterOptions:(x) => x,
              }
        },

        {
          key:"fecha_entrega",
          keyValue:"fecha_entrega",
          label:"Fecha de entrega",
          component:DatePickerInputWithLabel,
          responsiveSize:6,
          inputProps:{
            type:"date",
            size:"small",
           }
        },
       ],
      arrayInputs:[],
      FooterElement:()=>null
    } ;






     const {configClientCreation} = useClientCreationPedido({callbackOnCreate:()=>{},maestrosCompartidos});
     const {configCreationPedido,OnResetConfigEnv} = useCreationPedido({callbackOnCreate:loadItems,maestrosCompartidos,defaultEntity:productoSeleccionado,tipoAction});
     const {configClientActivacion} = useClientActivacion({callbackOnCreate:loadItems,maestrosCompartidos});

     const openOrCloseModalMultiple = ()=>{
      OnResetConfigEnv();
      setProductoSeleccionado({...defaultEntity});
      
      setTipoAction(FormActions.AGREGAR);
      set_is_visible_modal_multiple( !is_visible_modal_multiple);
     }

    return (<>

    {
      <ModalFormMultiple
        dialog_title="CONTROL DE PEDIDOS"
        onOpen={openOrCloseModalMultiple}
        onClose={openOrCloseModalMultiple}
        is_visible={is_visible_modal_multiple}
        arrayOfForms={[configCreationPedido,configClientCreation,configClientActivacion]}
      />
    }

    <YesNotDialog
    {...dialogYesConfig}
    />

{
      dialogExportConfig.isVisible && 
      <ModalFormGenerador
       isVisible={dialogExportConfig.isVisible}
       schemaValidator={schemaDescargarPedidos}
       typeAction={FormActions.AGREGAR}
       {
        ...configDescargaPedido
       }
       onSendForm={onDownloadFile}
     />
    }

    {
      isVisibleModalDetalle &&
    <ModalVerPedidos 
    visibleModal={isVisibleModalDetalle}
    productInfo={productoSeleccionado}
    onSendForm={onSaveDataForm}
    onCloseModal={()=>setIsVisibleModalDetalle(false)}
    estadosPedidos={estadosOptions}
    onUpdateStatusRequest={onUpdateStatusRequest}
    />
    }

    <ModalLanzarNecesidad 
     visibleModal={isVisibleModalLanzar}
     productInfo={productoSeleccionado}
     onCloseModal={()=>setIsVisibleModalLanzar(false)}
     LanzarNecesidades={onCreateNecesidades}
    />
   
    <Grid container spacing={2} >

        <Grid item sm={12} xs={12} md={12} >
        <FilterForm
            buttomDist={
              {
                sx:2,
                md:2
              }
            }
           
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            { product_select:null,
              fecha_entrega:null,
              estado_pedido:null
             
             }
            }
            onApplyFilter={setFilterAply}
          />
        </Grid>
       
        <Grid item sm={12} xs={12} md={12} >
            <Stack direction={"row"} alignItems={"end"} spacing={1} >
            <Button onClick={openOrCloseModalMultiple}  variant="contained" size="small" >Nuevo pedido</Button>
              <Button disabled={profile.perfil?.descripcion === 'vendedor'} onClick={e=>setDialogExportConfig({isVisible:true})}  variant="contained" color="secondary" size="small" >Descargar pedidos</Button>
            </Stack>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer  >
               <Table>
            <TableHead>
              <TableRow>

                { !is_mobile?
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                  :<TableCell></TableCell>
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >
                    
                    { !is_mobile?
                      columnsTable.map(Col=>
                        <TableCell key={prod.cod+"-"+Col.keyValue}  >
                          {<Col.bodyRender value={prod[Col.keyValue]} otherProps={prod} />}
                       </TableCell>)
                       :<TableCell  >
                        <Card>
                           <CardContent>
                             <Typography variant="subtitle1" >PEDIDO ID: {prod.cod}</Typography><br/>
                             <Typography variant="caption" >FECHA DE ENTREGA: {dayjs(prod.fecha_entrega).format(DateFormatString)}</Typography><br/>
                             <Typography variant="caption" >CLIENTE: {prod.nombre_cliente}</Typography><br/>
                             <Typography variant="caption" >VALOR: $ {FormatPrice(prod.total_valor_pedido, 0)}</Typography><br/>
                             <Chip color={EstadosPedido[prod.estado_nombre]?.color} label={EstadosPedido[prod.estado_nombre]?.label} /><br/>
                             <CustomContextMenu
                               buttomProps={{ fullWidth: true, sx: { marginTop: '5px' } }}
                               title_basic="Acciones"
                               menuItems={[
                                 {
                                   label: prod. tipo_pedido !== 'PEDIDO' ? 'Descargar cotización' : "Descargar pedido",
                                   onClick: () => DownloadDocumento(prod.cod, prod.tipo_pedido === 'PEDIDO' ? 'PV' : 'CT'),
                                   disabled: !["PEDIDO", "COTIZACION"].includes(prod.tipo_pedido)
                                 },
                                 {
                                   label: "Editar pedido",
                                   onClick: () => onEditPedido(prod.cod),
                                   disabled: !['RECIBIDO', 'CREADO', 'EN-ALISTAMIENTO', 'ALISTADO', "PROCESADO-CON-ERROR"].includes(prod.estado_nombre)
                                 },
                                 {
                                   label: "Ver detalle",
                                   onClick: e => onShowDetailProduct(prod.cod),
                                   disabled: false
                                 },
                                 {
                                   label: "Ver errores",
                                   onClick: e => ShowLogErrores(prod.log_errores),
                                   disabled: prod.log_errores ? false : true

                                 },
                                 {
                                   label: "Lanzar necesidad",
                                   onClick: e => LanzarNecesidad(prod),
                                   disabled: prod.tipo_pedido === 'PEDIDO' || prod.tipo_pedido === 'COTIZACION'
                                 },
                                 {
                                   label: "Convertir a pedido",
                                   onClick: e => ConvertirCotizacionToPedido(prod.cod),
                                   disabled: prod.tipo_pedido === 'PEDIDO' || prod.estado_nombre !== 'EN-ESPERA' || dayjs().isAfter(prod.vigencia)
                                 },

                               ]}
                             />
                           </CardContent>

                        </Card>

                       </TableCell>
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}